import { PERSONAL_INFO } from "../../data/portfolioData";
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <p className={styles.text}>
        © {new Date().getFullYear()} {PERSONAL_INFO.name}. All rights reserved.
      </p>
    </footer>
  );
}
